import React, {useEffect, useState} from "react";
import {ILabelDto} from "../../../../../common/apis/label/ILabelDto";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import {
    BulkOperationsLabelsTranslation
} from "./BulkOperationsLabelsTranslation";
import labelsService from "../../labels/service/LabelsService";
import Snackbar from "../../snackbar/Snackbar";
import {LabelsTranslationKey} from "../../labels/LabelsTranslationKey";
import Api from "../../../../../common/Api";
import LabelsDialog from "../../labels/LabelsDialog";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import {IconButton, Tooltip} from "@mui/material";
import {LocalOffer} from "@mui/icons-material";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import PickList from "../../../../../components/picklist/PickList";
import DialogActions from "../../../../../components/dialogs/DialogActions";
import {CancelButton} from "../../../../../components/button/CancelButton";
import Dialog from "../../../../../components/dialogs/Dialog";
import {DiagramInfoDto} from "../../../../../common/apis/diagram/DiagramInfoDto";
import {SaveButton} from "../../../../../components/button/SaveButton";

interface AddBulkLabelsToDiagramsDialogProps {
    isOpened: boolean,
    onClosed: () => void,
    diagrams: DiagramInfoDto[]
    refetchFilter: () => void,
}

export default function AddBulkLabelsToDiagramsDialog(props: AddBulkLabelsToDiagramsDialogProps) {
    const {isOpened, onClosed, diagrams, refetchFilter} = props;

    const [labels, setLabels] = useState<ILabelDto[]>([]);
    const [reload, setReload] = useState<number>(0);
    const [labelsAdministration, setLabelsAdministration] = useState<boolean>(false);
    const [pickedOptions, setPickedOptions] = useState<ILabelDto[]>([]);

    useEffect(() => {
        if (!isOpened) {
            setLabels([]);
        } else {
            let isUnmounted = false;
            labelsService.getAll()
                .then((allLabels) => {
                    if (!isUnmounted) {
                        setLabels(diagrams.find(value => !value.acl.canUpdatePublicLabels) ? allLabels.filter(value => !value.publicLabel) : allLabels);
                    }
                })
                .catch((error) => Snackbar.error(_transl(LabelsTranslationKey.NOT_FETCHED)));
            return () => {
                isUnmounted = true;
            }
        }
    }, [reload, diagrams, isOpened]);

    function saveChanges() {
        const labelCodes = (pickedOptions as ILabelDto[]).map(options => options.code);
        Api.diagrams.bulkAssignLabels(labelCodes, diagrams.map(value => value.identifier))
            .subscribe(
                () => {
                    onClosed();
                    refetchFilter();
                },
                (err) => {
                    Snackbar.error(_transl(BulkOperationsLabelsTranslation.LABELS_ADD_FAILED_TEXT), err);
                }
            );
    }

    return (
        <React.Fragment>
            <LabelsDialog open={labelsAdministration}
                          onClosed={() => {
                              setLabelsAdministration(false);
                              setReload(reload + 1);
                          }}/>
            <Dialog open={isOpened}
                    aria-labelledby="picklist-dialog-title"
                    onClose={onClosed}
                    fullWidth={true}
                    maxWidth={'md'}>
                <DialogTitle id="picklist-dialog-title"
                             title={_transl(BulkOperationsLabelsTranslation.LABELS_ADD_TITLE)}
                             onDialogClosed={onClosed}
                             right={
                                 <Tooltip title={_transl(LabelsTranslationKey.ADMINISTRATION_TOOLTIP)}>
                                     <IconButton onClick={() => setLabelsAdministration(true)}>
                                         <LocalOffer/>
                                     </IconButton>
                                 </Tooltip>}/>
                <DialogContent>
                    <PickList
                        initialAvailableOptions={labels}
                        initialPickedOptions={[]}
                        getOptionText={(item: unknown) => item ? (item as ILabelDto).name : ""}
                        availableOptionsTitle={_transl(BulkOperationsLabelsTranslation.LABELS_AVAILABLE_OPTIONS)}
                        pickedOptionsTitle={_transl(BulkOperationsLabelsTranslation.LABELS_ADD_TITLE_PICKED_OPTIONS)}
                        onPickedOptionsUpdated={(pickedOptions) => setPickedOptions(pickedOptions as Array<ILabelDto>)}/>
                </DialogContent>
                <DialogActions>
                    <SaveButton onClick={saveChanges} disabled={pickedOptions.length === 0}/>
                    <CancelButton onClick={onClosed}/>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}